import { FormGroup } from "@blueprintjs/core";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import {
  EnumSingleSelectProps,
  FieldLabeledProps,
  EnumSingleSelectFieldValue,
  Option,
} from "../../types/fieldTypes";
import {
  EnumSingleSelectPropType,
  useEnumSingleSelectFieldV2,
} from "./useEnumSingleSelectFieldV2";
import { SelectEventArgs } from "@syncfusion/ej2-react-dropdowns";
import { SecondaryButton } from "../../../Buttons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
/**Interface for EnumSingleSelectField*/
export interface EnumSingleSelectFieldV2Props
  extends EnumSingleSelectProps,
    Omit<
      EnumSingleSelectPropType,
      "width" | "value" | "select" | "showClearButton"
    > {
  readonly type: "EnumSingleSelect";
  reorderOptions?: ReorderOption[];
  sortFunction?: (
    x: Option<EnumSingleSelectFieldValue>,
    y: Option<EnumSingleSelectFieldValue>
  ) => number;
  optionsFilter?: (option: Option<EnumSingleSelectFieldValue>) => boolean;
  noResultsLabel?: string;
  labelProps?: FieldLabeledProps;
  select?: (args: SelectEventArgs) => void;
  showClearButton?: boolean;
  hideSearchBox?: boolean;
  searchMethod?: "contains" | "startswith";
}

/** Used for reordering OptionValues of the dropdown*/
export interface ReorderOption {
  newIndex: number;
  value: string | number;
}

/**Single Select is used primarily with enum values from the API, but can be passed collection of arrays*/
export const EnumSingleSelectFieldV2: React.FC<EnumSingleSelectFieldV2Props> = (
  props
) => {
  const module = useEnumSingleSelectFieldV2(props);

  return (
    <FormGroup
      key={module.localValue}
      className={classNames("enum-single-select-field-v2", {
        "has-required-background": props.isRequired && !module.localValue,
      })}
    >
      {props.label && (
        <FieldLabel
          labelName={props.label}
          tooltipDescription={props.description}
          fieldProps={{ ...props, value: module.localValue }}
          isRequired={props.isRequired}
          {...props.labelProps}
        />
      )}
      {module.ready && (
        <div className="select-field-input">
          <DropDownListComponent
            ref={module.singleSelectRef}
            {...module.settings}
            // open={() => {
            //   debugger;
            // }}
          />
          {props.showClearButton !== false && (
            <SecondaryButton
              type="button"
              minimal={true}
              disabled={props.disabled}
              className="select-field-clear-button"
              onClick={() => {
                if (props.disabled !== true) {
                  module.setLocalValue(undefined);
                }
              }}
            >
              <FontAwesomeIcon icon={faClose} />
            </SecondaryButton>
          )}
        </div>
      )}
      {props.errorMessages && (
        <FormFieldErrorContainer errorMessages={props.errorMessages} />
      )}
    </FormGroup>
  );
};
